// import axios from "axios"
import axios from "axios";
import toast from "react-hot-toast";
export default function http() {
    const _token = localStorage.getItem("token");
    const instance = axios.create({
        // baseURL: "http://192.168.0.233:5000/api/",
        baseURL:
            process.env.NODE_ENV === "development"
                ? `https://localhost:${7045}/api/`
                : "https://amlakto.com/api/"
    });
    // set headers
    /* --------------------- axios instance ----------------------- */
    // Add a request interceptor
    instance.interceptors.request.use(
        async function (config) {
            // Set Authentication Before Requesting
            if (_token) {
                config.headers.Authorization = "Bearer " + _token;
            }
            return config;
        },
        function (error) {
            // Do something with request error
            return Promise.reject(error);
        }
    );
    // Add a response interceptor
    instance.interceptors.response.use(
        function (response) {
            // Any status code that lie within the range of 2xx cause this function to trigger
            // Do something with response data
            if (response?.data?.status !== true) {
                errors_handler(response);
            }
            return response;
        },
        function (error) {
            // Any status codes that falls outside the range of 2xx cause this function to trigger
            // Do something with response error
            return Promise.reject(error);
        }
    );
    let error_display = (data, statusText) => {
        // toast notification
        if (!data) return;
        if (data?.errors) {
            toast.error(data?.errors[Object.keys(data.errors)[0]], {});
        } else {
            toast.error(data.message);
        }
    };
    let success_display = (status) => {
        // toast notification
        if (!status) return;
        if (status.message) {
            status.isSuccess
                ? toast.success(status.message)
                : toast.error(status.message);
        }
    };
    /* --------------------- axios instance errors ----------------------- */
    function errors_handler(error) {
        if (error?.data?.message && error?.data.success === false) {
            // error_display(error, error?.data?.message);
            return;
        }

        if (!error && !error.response && !error.response.data) {
            return;
        }
        let current_error = error?.response?.data;
        let current_error_status = error?.response?.status;
        let current_error_message = current_error?.message;

        // eslint-disable-next-line default-case
        switch (current_error_status) {
            case 200:
                //bad request
                success_display(current_error, current_error_message);
                break;
            case 400:
                //bad request
                error_display(current_error, current_error_message);
                break;
            case 401:
                //unauthenticate
                localStorage.removeItem("token");
                // window.location="/register"
                // RootNavigation.navigate("Start");
                error_display(current_error, current_error_message);
                break;
            case 403:
                //unauthenticate
                // RootNavigation.navigate("Start");
                error_display(current_error, current_error_message);
                break;
            case 404:
                //unauthenticate
                // RootNavigation.navigate("Start");
                error_display(current_error, current_error_message);
                // window.location = "/404";
                break;
            case 410:
                //unauthenticate
                error_display(current_error, current_error_message);
                break;
            case 422:
                error_display(current_error, current_error_message);
                break;
            case 500:
                //server error
                // if (typeof window !== "undefined") AsyncStorage.removeItem("token");
                // if (typeof window !== "undefined") navigation.navigate("Start");
                error_display(current_error, current_error_message);
                break;
        }
    }
    /* --------------------- axios instance ----------------------- */
    return {
        // ********
        // public api
        // ********
        Login: (callback, data, errCallback) => {
            return instance
                .post("Token/LoginSupport", data)
                .then((data) => {
                    callback(data);
                    success_display(data.data);
                })
                .catch((err) => {
                    if (errCallback) errCallback(err);
                    errors_handler(err);
                });
        },
        // **********
        // chat controller api
        // ***********
        GetRooms: (callback, data, errCallback) => {
            return instance
                .get(`/Chat/GetRooms`, data)
                .then((data) => {
                    callback(data);
                    success_display(data.data);
                })
                .catch((err) => {
                    if (errCallback) errCallback(err);
                    errors_handler(err);
                });
        },
        GetChatReports: (callback, data, errCallback) => {
            return instance
                .get(`/Chat/GetChatReports`, data)
                .then((data) => {
                    callback(data);
                    success_display(data.data);
                })
                .catch((err) => {
                    if (errCallback) errCallback(err);
                    errors_handler(err);
                });
        },
        ReportChat: (callback, data, errCallback) => {
            return instance
                .post(`/Chat/ReportChat`, data)
                .then((data) => {
                    callback(data);
                    success_display(data.data);
                })
                .catch((err) => {
                    if (errCallback) errCallback(err);
                    errors_handler(err);
                });
        },
        RemoveRoom: (callback, data, errCallback) => {
            return instance
                .post(`/Chat/RemoveRoom?roomId=` + data, data)
                .then((data) => {
                    callback(data);
                    success_display(data.data);
                })
                .catch((err) => {
                    if (errCallback) errCallback(err);
                    errors_handler(err);
                });
        },
        GetMessages: (callback, data, errCallback) => {
            return instance
                .get(`/Support/GetMessages?roomId=${data}`, data)
                .then((data) => {
                    callback(data);
                    success_display(data.data);
                })
                .catch((err) => {
                    if (errCallback) errCallback(err);
                    errors_handler(err);
                });
        },
        UpdateIsRead: (callback, data, errCallback) => {
            return instance
                .post(`/Chat/UpdateIsRead?roomId=${data}`, data)
                .then((data) => {
                    callback(data);
                    success_display(data.data);
                })
                .catch((err) => {
                    if (errCallback) errCallback(err);
                    errors_handler(err);
                });
        },
        SendMessage: (callback, data, errCallback, option) => {
            instance.defaults.headers.common["Content-Type"] = "multipart/form-data";
            return instance
                .post(`/Chat/SendMessage`, data, option)
                .then((data) => {
                    callback(data);
                    success_display(data?.data);
                })
                .catch((err) => {
                    if (errCallback) errCallback(err);
                    errors_handler(err);
                });
        },
        RemoveMessage: (callback, data, errCallback) => {
            instance.defaults.headers.common["Content-Type"] = "multipart/form-data";
            return instance
                .post(`/Chat/RemoveMessage`, data)
                .then((data) => {
                    callback(data);
                    success_display(data.data);
                })
                .catch((err) => {
                    if (errCallback) errCallback(err);
                    errors_handler(err);
                });
        },
        // **********
        // support controller api
        // ***********
        GetCurrentChats: (callback, data, errCallback) => {
            return instance
                .get(`/Support/GetCurrentChats`, data)
                .then((data) => {
                    callback(data);
                    success_display(data.data);
                })
                .catch((err) => {
                    if (errCallback) errCallback(err);
                    errors_handler(err);
                });
        },
        GetNewChats: (callback, data, errCallback) => {
            return instance
                .get(`/Support/GetNewChats`, data)
                .then((data) => {
                    callback(data);
                    success_display(data.data);
                })
                .catch((err) => {
                    if (errCallback) errCallback(err);
                    errors_handler(err);
                });
        },
        AssignChatToSupport: (callback, data, errCallback) => {
            return instance
                .post(`/Support/AssignChatToSupport?chatId=` + data)
                .then((data) => {
                    callback(data);
                    success_display(data.data);
                })
                .catch((err) => {
                    if (errCallback) errCallback(err);
                    errors_handler(err);
                });
        },
    };
}
